var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E00751",
    d: "M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0 13.636A6.133 6.133 0 0 1 1.364 7.5 6.132 6.132 0 0 1 7.5 1.364 6.133 6.133 0 0 1 13.636 7.5 6.133 6.133 0 0 1 7.5 13.636z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E00751",
    d: "M7.5 9.034a.684.684 0 0 0 .682-.682v-3.92A.684.684 0 0 0 7.5 3.75a.684.684 0 0 0-.682.682v3.92c0 .375.307.682.682.682zm0 2.438a.852.852 0 1 0 0-1.705.852.852 0 0 0 0 1.705z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.af106518a5f6815647766910da139f8d.svg";
export { ForwardRef as ReactComponent };